<template>
  <div class="loginBox">
    <auth-logo />
    <van-tabs
      @click="onClick"
      v-model="active"
      class="loginTabs"
      animated
      v-if="isTimePassed(testTime)"
    >
      <van-tab :title="$t.auth.login"></van-tab>
      <van-tab :title="$t.auth.register"></van-tab>
    </van-tabs>

    <!-- 表单 -->
    <div class="formBox">
      <div class="radioBox">
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio :name="1" checked-color="#00e0b6" class="staff">{{
            $t.auth.staff
          }}</van-radio>
          <van-radio :name="2" checked-color="#00e0b6" class="customer">{{
            $t.auth.customer
          }}</van-radio>
        </van-radio-group>
      </div>
      <div class="selectBox" v-if="radio == 1">
        <div class="accountType" @click="showAccountTypePicker = true">
          <span style="margin-right: 5px">{{ auth.AccountTypeStr }}</span>
          <span><van-icon name="sort" /></span>
        </div>
      </div>
      <div v-if="radio == 1">
        <div class="inputBox" v-if="auth.AccountType == 1">
          <input
            class="username"
            v-model="auth.phoneNumber"
            type="text"
            :placeholder="$t.auth.inputPhoneNumber"
          />
        </div>
        <div class="inputBox" v-if="auth.AccountType == 2">
          <input
            class="username"
            v-model="auth.email"
            type="text"
            :placeholder="$t.auth.inputEmail"
          />
        </div>
      </div>
      <div class="inputBox box1" v-if="radio == 2">
        <input
          class="username"
          v-model="auth.customerNumber"
          type="text"
          :placeholder="$t.auth.inputCustomerNumber"
        />
      </div>
      <div class="inputBox">
        <input
          class="password"
          v-model="auth.password"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$t.auth.inputPassword"
        />
        <van-icon
          name="eye-o"
          v-if="showPassword"
          @click="showPassword = !showPassword"
        />
        <van-icon name="closed-eye" v-else @click="showPassword = !showPassword" />
      </div>
      <div class="next" @click="onlogin">{{ $t.auth.login }}</div>
      <div class="terms">
        <div class="termsCheckbox">
          <van-checkbox v-model="checked" checked-color="#00e0b6"></van-checkbox>
        </div>
        <div @click="gotoPrivacy" class="termsText">
          {{ $t.auth.rulesAndProtocols }}
        </div>
      </div>
      <div class="forget" @click="onforget">{{ $t.auth.forgetPassword }}?</div>
    </div>

    <van-popup v-model="showAccountTypePicker" round position="bottom">
      <van-picker
        :title="$t.auth.pickerType1"
        show-toolbar
        :columns="accountTypeOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="accountTypeConfirm($event)"
        @cancel="showAccountTypePicker = false"
      />
    </van-popup>

    <van-dialog
      :title="$t.auth.verifyText"
      width="90%"
      v-model="verifyVisible"
      @confirm="verifyConfirm"
      @cancel="verifyCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
    >
      <slot name="default">
        <div class="loginBox-alert">
          <van-form label-width="80px">
            <van-field
              v-model="auth.verificationCode"
              :label="$t.auth.verifyCode"
              label-class="number-label"
              :placeholder="$t.meta.input"
              required
              :maxlength="6"
            >
              <template #button>
                <van-button
                  size="small"
                  type="info"
                  @click="sendCode"
                  :disabled="!isShowCode ? true : false"
                >
                  <span v-if="isShowCode">{{ $t.auth.get }}</span>
                  <span v-else>{{ timerNum }}S</span>
                </van-button>
              </template>
            </van-field>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <auth-background />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";
import AuthLogo from "./components/AuthLogo";
import AuthBackground from "./components/AuthBackground";
import {
  Tab,
  Tabs,
  Checkbox,
  RadioGroup,
  Radio,
  Icon,
  Popup,
  Picker,
  Form,
  Field,
  Button,
} from "vant";
import { getPlatform } from "@/plugins/environment/type.js";
import Vue from "vue";
import md5 from "js-md5";

Vue.use(Tab)
  .use(Tabs)
  .use(Checkbox)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Popup)
  .use(Picker)
  .use(Form)
  .use(Field)
  .use(Button);

export default {
  name: "login",
  components: {
    AuthLogo,
    AuthBackground,
  },
  data() {
    return {
      active: 0,
      radio: 1,
      auth: {
        AccountType: 1,
        AccountTypeStr: this.$t.auth.phoneNumber,
        phoneNumber: "",
        email: "",
        customerNumber: "",
        password: "",
        verificationCode: "",
      },
      checked: false,
      showPassword: false,
      platform: getPlatform(),
      testTime: "2025-11-24 14:00:00",
      accountTypeOptions: [
        {
          text: this.$t.auth.phoneNumber,
          value: 1,
        },
        {
          text: this.$t.auth.email,
          value: 2,
        },
      ],
      showAccountTypePicker: false,
      //验证账号
      verifyVisible: false,
      //倒计时
      isShowCode: true,
      timerNum: 0,
      timerItem: null,
    };
  },
  methods: {
    accountTypeConfirm(e) {
      this.auth.AccountTypeStr = e.text;
      this.auth.AccountType = e.value;
      this.showAccountTypePicker = false;
    },
    gotoPrivacy() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "privacy",
        name: "privacy",
        query: [],
      });
    },
    onforget() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/resetPassword",
        name: "ResetPassword",
        query: [],
      });
    },
    onlogin() {
      if (!this.checked) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.auth.tick + this.$t.auth.rulesAndProtocols,
        });
        return false;
      }
      if (this.radio == 1) {
        if (this.auth.phoneNumber == "" && this.auth.email == "") {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputUsername,
            type: "danger",
          });
          return false;
        }
      }
      if (this.radio == 2) {
        if (this.auth.customerNumber == "") {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCustomerNumber,
            type: "danger",
          });
          return false;
        }
      }
      if (this.auth.password == "") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.auth.inputPassword,
          type: "danger",
        });
        return false;
      }
      var param = {
        //LoginTokenTest: true,
      };
      var request = null;
      if (this.radio == 1) {
        if (this.auth.AccountType == 2) {
          param.AccountType = this.auth.AccountType;
          param.Email = this.auth.email;
          param.Password = md5(this.auth.password);
          param.VerificationCode = this.auth.verificationCode;
        } else {
          param.AccountType = this.auth.AccountType;
          param.PhoneNumber = this.auth.phoneNumber;
          param.Password = md5(this.auth.password);
          param.VerificationCode = this.auth.verificationCode;
        }
        request = this.$api.user.userLogin(param);
      }
      if (this.radio == 2) {
        param.CustomerNumber = this.auth.customerNumber;
        param.Password = this.auth.password;
        request = this.$api.user.loginByCustomer(param);
      }
      this.$commonMethod.showLoading();
      request
        .then((res) => {
          if (res.IsExpire) {
            this.verifyVisible = true;
          } else {
            this.verifyVisible = false;
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
              titleMsg: this.$t.auth.logInSuccess,
              type: "success",
            });
            this.SET_AUTH(res.data);
            this.loginAction(res.data);
          }
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    loginAction(data) {
      if (this.radio == 1) {
        if (data.IsUse == 1 && data.CompanyCode) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: false,
            path: "home",
            name: "Home",
            query: [],
          });
        } else if (data.IsUse == -1 || !data.CompanyCode) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: false,
            path: "activate",
            name: "Activate",
            query: [],
          });
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.auth.freeze,
          });
        }
      }
      if (this.radio == 2) {
        if (data) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: false,
            path: "home",
            name: "Home",
            query: [],
          });
        }
      }
    },
    onClick(index) {
      if (index == 1) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: false,
          path: "auth/register",
          name: "Register",
          query: [],
        });
      }
    },
    verifyConfirm() {
      if (!this.auth.verificationCode) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.auth.inputVcode,
          type: "danger",
        });
        return;
      }
      this.onlogin();
    },
    verifyCancel() {
      this.verifyVisible = false;
    },
    sendCode() {
      const checkPhone = /^1[3|4|5|8][0-9]\d{4,8}$/;
      const phone = this.auth.phoneNumber;
      const checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const email = this.auth.email;
      if (this.auth.AccountType == 1) {
        if (checkPhone.test(phone)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentPhoneNumber,
            type: "danger",
          });
        }
      }
      if (this.auth.AccountType == 2) {
        if (checkEmail.test(email)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentEmail,
            type: "danger",
          });
        }
      }
    },
    sendVerificationCode() {
      this.$commonMethod.showLoading();
      var param = {
        AccountType: this.auth.AccountType,
        Phone: this.auth.phoneNumber,
        Email: this.auth.email,
      };
      this.$api.user
        .sendVerificationCode(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.verificationCodeInfo,
            type: "success",
          });
          //启动定时器
          this.timerTime();
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          //启动定时器
          this.timerTime();
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    //定时器
    timerTime() {
      this.timerNum = 60;
      this.isShowCode = false;
      this.timerItem = setInterval(() => {
        this.timerNum--;
        if (this.timerNum < 1) {
          clearInterval(this.timerItem);
          this.isShowCode = true;
        }
      }, 1000);
    },
    isTimePassed(targetTime) {
      const now = new Date();
      const target = new Date(targetTime);
      return now >= target;
    },
    ...mapMutations([SET_AUTH]),
  },
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";

.loginBox {
  position: relative;
  width: 100%;
  .loginTabs {
    ::v-deep .van-tabs__nav {
      background: rgba(0, 0, 0, 0.1);
    }
    ::v-deep .van-tabs__wrap {
      width: 60%;
      border-radius: 10rem;
      margin: auto;
      border: none !important;
    }
    ::v-deep .van-tab {
      color: #fff;
      font-weight: bold;
    }
    ::v-deep .van-tab--active {
      border-radius: 10rem;
      background: #fff;
      color: #304156;
    }
    ::v-deep .van-hairline--top-bottom::after {
      display: none;
    }
    ::v-deep .van-tabs__line {
      display: none;
    }
    ::v-deep .van-tab__text {
      font-size: 1rem;
      line-height: 2;
      overflow: visible;
    }
  }
  ::v-deep .number-label {
    line-height: 33px;
  }
  .loginBox-alert {
    overflow: scroll;
    max-height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  //表单
  .formBox {
    width: 85%;
    position: relative;
    margin: 0 auto;
    margin-top: 1.5rem;
    .formTitle {
      width: 190px;
      border-radius: 50px;
      background-color: #ffffff;
      color: #6dc093;
      height: 24px;
      font-size: 26px;
      text-align: center;
      height: 70px;
      line-height: 70px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
    }
    .radioBox {
      text-align: center;
      .van-radio-group {
        display: inline-flex;
        .staff {
          margin-right: 20px !important;
        }
        .customer {
          margin-right: 0px !important;
        }
      }
      ::v-deep .van-radio__icon {
        color: #fff;
        font-size: 18px !important;
      }
      ::v-deep .van-radio__label {
        color: #fff;
        font-size: 14px !important;
      }
    }
    .selectBox {
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      width: 100%;
      @include publicFlex;
      .accountType {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 0.8rem;
        width: 100%;
        height: 20px;
        line-height: 20px;
        padding: 0 1.5rem;
        box-sizing: border-box;
        text-align: right;
      }
    }
    .box1 {
      margin-top: 28px !important;
    }
    .inputBox {
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      width: 100%;
      @include publicFlex;
      .username,
      .password {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 1rem;
        width: 100%;
        height: 50px;
        line-height: normal;
        border: 0.1rem solid #ffffff;
        border-radius: 100px;
        padding: 0 1.5rem;
        box-sizing: border-box;
        &::placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
        &::-webkit-input-placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
      }
      .code {
        width: 400px !important;
      }
      .getCode,
      .codeInfo {
        outline: none;
        border: 0;
        height: 95px;
        line-height: 95px;
        width: 185px;
        background-color: #ffffff;
        color: #304156;
        font-size: 24px;
        text-align: center;
        border-radius: 80px;
        overflow: hidden;
      }
      .codeInfo {
        font-size: 30px;
        background-color: #dcdcdc;
        color: #ffffff;
      }
      .van-icon {
        position: absolute;
        right: 5%;
        color: #ffffff;
      }
    }
    .next {
      width: 100%;
      border-radius: 50px;
      line-height: 50px;
      text-align: center;
      color: #304156;
      font-size: 1rem;
      font-weight: bold;
      background-color: #f3faf8;
      margin-top: 20px;
    }
    .InvitationCode {
      margin-top: 20px;
      font-size: 24px;
      width: 100%;
      height: 96px;
      line-height: 96px;
      border: 1px solid #b9e1da;
      border-radius: 100px;
      padding: 0 47px;
      box-sizing: border-box;
      color: #000000;
      font-size: 30px;
      font-family: Helvetica;
      font-weight: 400;
      opacity: 0.3;
    }
    .terms {
      margin-top: 30px;
      font-size: 13px;
      color: #ffffff;
      .termsCheckbox {
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        width: 20%;
        .van-checkbox {
          display: inline-block;
          vertical-align: middle;
          ::v-deep .van-checkbox__icon {
            color: #fff;
            font-size: 18px !important;
          }
        }
      }
      .termsText {
        display: inline-block;
        text-align: left;
        vertical-align: middle;
        width: 80%;
      }
    }
    .forget {
      margin-top: 30px;
      color: #00e0b6;
      text-align: center;
      font-size: 12px;
    }
  }
}
</style>
